import EmployerProjectCard from './EmployerProjectCard';
export default EmployerProjectCard;